import type { AxiosError } from 'axios';

const serializeRequestError = (error: unknown) => {
  const { message, response } = error as AxiosError;
  return {
    data: response?.data ?? null,
    message,
    status: response?.status ?? null,
  };
};

export default serializeRequestError;
